import React from 'react';
import PropTypes from 'prop-types';
import { ROUTE_ADMIN_PATH } from 'routes';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadingAction } from 'store/globalState/global';
import { stopImpersonate } from '../modules/actions';
import './styles.scss';

function ImpersonateBar({ literalsCommon, user }) {
  const literals = useSelector(state => state.i18n.literals.leftMenu);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleStop = async () => {
    await dispatch(loadingAction(true));
    await stopImpersonate();
    navigate(ROUTE_ADMIN_PATH.USERS, { replace: true });
    await dispatch(loadingAction(false));
  };

  return (
    <div className='impersonate-bar'>
      <span>{literals.youAreImpersonating}</span>
      <span className='impersonate-bar--email ps-1'>{`(${user.email})`}</span>
      <div
        className='impersonate-bar--button'
        onClick={handleStop}
      >
        {literalsCommon.stop}
      </div>
    </div>
  );
}

ImpersonateBar.propTypes = {
  literalsCommon: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default ImpersonateBar;
